import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 
const GetTestPingUrls =(params?:any)   =>
request({
  url: ApiURL.Query.GetTestPingUrls + `?environment=${params}`,
  method: RequestType.GET,
});
const PingToUrls =(data?:any)   =>
request({
  url: ApiURL.Query.PingToUrls,
  method: RequestType.POST,
  data:data
});

 
const TestPingQuery = {
  GetTestPingUrls,
  PingToUrls
};

export default TestPingQuery;
